import React, { useEffect, useState } from "react";
import { Dialog } from "@mui/material";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import IconButtonWrapper from "../../../../common/form-fields-mui/IconButtonWrapper";
import PaymentHistoryTable from "./PaymentHistoryTable";
import AButton from "../../../../common/form-fields-mui/AButton";
import { useGetCollectPaymentContext } from "../../context";
import { CourseIdComponent, RenderHeaderChip } from "../../header";
import { getFailedChequeDetails } from "../../apis";
import ALoader from "../../../../common/a-loader";

const getHeaderItems = (studentData) => {
  return [
    {
      label: "PSID",
      value: studentData?.psid,
    },
    {
      label: "Application ID",
      value: studentData?.applicationId,
    },
    {
      label: "Term",
      value: studentData?.term,
    },
  ];
};

const FailedChequeDetailsPopup = ({
  failedChequeHistoryScreen,
  setIsOpenFailedChequeHistoryScreen,
}) => {
  const { studentBasicDetails } = useGetCollectPaymentContext();
  const [loader, setLoader] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const { isOpenPopup, row } = failedChequeHistoryScreen;
  const headerChips = getHeaderItems({...studentBasicDetails, term:row?.term});
  const closeHandler = () => {
    setIsOpenFailedChequeHistoryScreen((prev) => ({
      ...prev,
      isOpenPopup: false,
      row: {},
    }));
  };
  //

  useEffect(() => {
    if (row && isOpenPopup) {
      const itemList = (row?.itemTypeWiseInstallmentsList || []).filter(
        (item) => item?.failedChequeHistory
      );

      if (itemList?.length > 0 || row?.failedChequeHistory) {
        let itemType = [itemList[0]?.itemType || row?.itemType];
        const { psid, bu, applicationId } = studentBasicDetails;
        const innerRows = (row?.itemTypeWiseInstallmentsList || [])
          .filter((item) => item?.failedChequeHistory)
          .map((item) => item?.itemType);
        itemType = [...itemType, ...innerRows]
        const request = {
          psid,
          applicationId,
          businessArea: bu,
          itemType :Array.from(new Set(itemType)),
          term: row?.term,
          courseId: row?.courseId,
        };
        setLoader(true);
        getFailedChequeDetails(request)
          .then((data) => {
            data?.code === 200 && setPaymentData(data?.data);
            setLoader(false);
          })
          .catch((error) => {
            setLoader(false);
          });
      }
      // fetch payment history data here
      // set loading to true
    }
  }, [row]);

  return (
    <>
      <Dialog onClose={closeHandler} open={isOpenPopup} maxWidth="lg">
        <div style={{ padding: "28px 24px", minWidth: "28rem" }}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            {loader && <ALoader />}
            <div className="heading-4 text-dark text-bold">
              Payment history for {row?.description} fees
            </div>
            <div>
              <IconButtonWrapper onClick={closeHandler}>
                <CrossIcon width={32} height={32} />
              </IconButtonWrapper>
            </div>
          </div>
          <div className="d-flex gap-md mb-4">
            {headerChips.map((headerItem) => (
              <RenderHeaderChip
                key={headerItem.label}
                label={headerItem.label}
                value={headerItem.value}
              />
            ))}
            <CourseIdComponent studentBasicDetails={{...studentBasicDetails, courseId:row?.courseId}} />
          </div>

          <div className="mt-1">
            Cheque return/ Cheque bounce found. Check below for more details-
          </div>
          <PaymentHistoryTable loading={loader} rows={paymentData} />
          <div className="d-flex align-item-center">
            <AButton
              className="button_remove_left_margin mt-2"
              onClick={closeHandler}
              variant="primary_filled"
              updatedStyle={{ width: "35%" }}
            >
              Okay
            </AButton>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default FailedChequeDetailsPopup;
